(function () {
  'use strict';

  var PARAMS = {
    gender: 'filter.v.t.shopify.target-gender',
    menSize: 'filter.v.m.custom.filter_size_mens_footwear',
    womenSize: 'filter.v.m.custom.filter_size_womens_footwear',
    unifiedSize: 'filter.v.m.custom.storefront_shoe_size_index'
  };

  var GENDER_VALUES = {
    female: 'gid://shopify/TaxonomyValue/18',
    male: 'gid://shopify/TaxonomyValue/19',
    unisex: 'gid://shopify/TaxonomyValue/20'
  };

  var scheduled = false;
  var nextSectionId = 0;

  function inputs(form, name) {
    return Array.prototype.slice.call(form.querySelectorAll('input[name="' + name + '"]'));
  }

  function inputByValue(list, value) {
    return list.find(function (input) {
      return input.value === value;
    });
  }

  function sourceGroup(input) {
    if (!input) return null;
    return input.closest('div[class*="collection-sidebar__group--"]') ||
      input.closest('.collection-sidebar__group');
  }

  function setChecked(list, selectedValues) {
    list.forEach(function (input) {
      input.checked = selectedValues.indexOf(input.value) !== -1;
    });
  }

  function isInputActive(input) {
    if (input.checked) return true;
    return new URL(window.location.href).searchParams.getAll(input.name).indexOf(input.value) !== -1;
  }

  function submitFilterForm(form, overrides) {
    var targetUrl = new URL(window.location.href);
    var formData = new FormData(form);

    Array.from(targetUrl.searchParams.keys()).forEach(function (name) {
      if (name.indexOf('filter.') === 0 || name === 'page') {
        targetUrl.searchParams.delete(name);
      }
    });

    formData.forEach(function (value, name) {
      if (String(value).trim() !== '') {
        targetUrl.searchParams.append(name, value);
      }
    });

    if (overrides) {
      Object.keys(overrides).forEach(function (name) {
        targetUrl.searchParams.delete(name);
        overrides[name].forEach(function (value) {
          targetUrl.searchParams.append(name, value);
        });
      });
    }

    window.location.assign(targetUrl.toString());
  }

  function currentContext(genderInputs) {
    var selectedGenderValues = new URL(window.location.href).searchParams.getAll(PARAMS.gender);
    if (selectedGenderValues.indexOf(GENDER_VALUES.male) !== -1) return 'men';
    if (selectedGenderValues.indexOf(GENDER_VALUES.female) !== -1) return 'women';

    var male = inputByValue(genderInputs, GENDER_VALUES.male);
    var female = inputByValue(genderInputs, GENDER_VALUES.female);

    if (male && isInputActive(male) && (!female || !isInputActive(female))) return 'men';
    if (female && isInputActive(female) && (!male || !isInputActive(male))) return 'women';
    return 'all';
  }

  function countFromInput(input) {
    var label = input.closest('label');
    var match = label && label.textContent.match(/\((\d+)\)\s*$/);
    return match ? match[1] : '';
  }

  function cleanSize(value) {
    var separator = value.indexOf(':');
    return separator === -1 ? value : value.slice(separator + 1);
  }

  function numericSizeSort(a, b) {
    var aNumber = Number(a.label);
    var bNumber = Number(b.label);

    if (!Number.isNaN(aNumber) && !Number.isNaN(bNumber)) {
      return aNumber - bNumber;
    }

    return a.label.localeCompare(b.label, undefined, { numeric: true });
  }

  function makeButton(label, className, pressed) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = className;
    button.textContent = label;
    button.setAttribute('aria-pressed', pressed ? 'true' : 'false');
    return button;
  }

  function sectionStorageKey(key) {
    return 'noUnifiedFootwearFilter:v2:' + key;
  }

  function storedSectionExpanded(key) {
    try {
      return window.sessionStorage.getItem(sectionStorageKey(key)) === 'true';
    } catch (error) {
      return false;
    }
  }

  function applySectionState(key, expanded) {
    document.querySelectorAll('[data-no-filter-section="' + key + '"]').forEach(function (section) {
      var toggle = section.querySelector('.no-unified-footwear-filter__toggle');
      var content = section.querySelector('.no-unified-footwear-filter__content');
      if (!toggle || !content) return;

      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      content.hidden = !expanded;
      section.setAttribute('data-collapsed', expanded ? 'false' : 'true');
    });

    try {
      window.sessionStorage.setItem(sectionStorageKey(key), expanded ? 'true' : 'false');
    } catch (error) {
      // Storage can be unavailable in privacy-restricted browser contexts.
    }
  }

  function createCollapsibleSection(label, key, forceExpanded) {
    nextSectionId += 1;

    var section = document.createElement('div');
    section.className = 'no-unified-footwear-filter__section';
    section.setAttribute('data-no-filter-section', key);

    var headingRow = document.createElement('div');
    headingRow.className = 'no-unified-footwear-filter__heading-row';

    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'no-unified-footwear-filter__toggle';

    var contentId = 'NoUnifiedFootwearFilter-' + key + '-' + nextSectionId;
    toggle.setAttribute('aria-controls', contentId);

    var heading = document.createElement('span');
    heading.className = 'no-unified-footwear-filter__heading';
    heading.textContent = label;

    var icon = document.createElement('span');
    icon.className = 'no-unified-footwear-filter__icon';
    icon.setAttribute('aria-hidden', 'true');

    toggle.appendChild(heading);
    toggle.appendChild(icon);
    headingRow.appendChild(toggle);

    var content = document.createElement('div');
    content.id = contentId;
    content.className = 'no-unified-footwear-filter__content';

    section.appendChild(headingRow);
    section.appendChild(content);

    var expanded = forceExpanded || storedSectionExpanded(key);
    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    content.hidden = !expanded;
    section.setAttribute('data-collapsed', expanded ? 'false' : 'true');

    if (forceExpanded) {
      try {
        window.sessionStorage.setItem(sectionStorageKey(key), 'true');
      } catch (error) {
        // Storage can be unavailable in privacy-restricted browser contexts.
      }
    }

    toggle.addEventListener('click', function () {
      applySectionState(key, toggle.getAttribute('aria-expanded') !== 'true');
    });

    return {
      section: section,
      headingRow: headingRow,
      content: content
    };
  }

  function hideSourceGroups(groups) {
    groups.forEach(function (group) {
      if (group) group.classList.add('no-filter-source--hidden');
    });
  }

  function relevantParamChanged(currentUrl, targetUrl) {
    return Object.keys(PARAMS).some(function (key) {
      var name = PARAMS[key];
      var current = currentUrl.searchParams.getAll(name).slice().sort().join('|');
      var target = targetUrl.searchParams.getAll(name).slice().sort().join('|');
      return current !== target;
    });
  }

  function hideNativeActiveTags(form) {
    var activeList = form.previousElementSibling;
    if (!activeList || !activeList.classList.contains('tag-list--active-tags')) return;

    var currentUrl = new URL(window.location.href);
    activeList.querySelectorAll('a[href]').forEach(function (link) {
      var targetUrl = new URL(link.href, currentUrl.href);
      if (relevantParamChanged(currentUrl, targetUrl)) {
        var item = link.closest('li');
        if (item) item.classList.add('no-filter-source--hidden');
      }
    });
  }

  function buildSizeOptions(context, menInputs, womenInputs, unifiedInputs) {
    var source = [];

    if (unifiedInputs.length) {
      var prefix = context === 'men' ? 'men:' : context === 'women' ? 'women:' : 'all:';
      source = unifiedInputs.filter(function (input) {
        return input.value.indexOf(prefix) === 0;
      });
    } else if (context === 'men') {
      source = menInputs;
    } else if (context === 'women') {
      source = womenInputs;
    }

    var seen = new Set();
    return source.map(function (input) {
      return {
        input: input,
        label: cleanSize(input.value),
        count: countFromInput(input)
      };
    }).filter(function (option) {
      if (seen.has(option.label)) return false;
      seen.add(option.label);
      return true;
    }).sort(numericSizeSort);
  }

  function setGender(form, context, genderInputs, menInputs, womenInputs, unifiedInputs) {
    var nextGenderValues = [];

    if (context === 'men') {
      nextGenderValues = [GENDER_VALUES.male, GENDER_VALUES.unisex];
    } else if (context === 'women') {
      nextGenderValues = [GENDER_VALUES.female, GENDER_VALUES.unisex];
    }

    setChecked(genderInputs, nextGenderValues);
    setChecked(menInputs, []);
    setChecked(womenInputs, []);
    setChecked(unifiedInputs, []);

    var overrides = {};
    overrides[PARAMS.gender] = nextGenderValues;
    overrides[PARAMS.menSize] = [];
    overrides[PARAMS.womenSize] = [];
    overrides[PARAMS.unifiedSize] = [];
    submitFilterForm(form, overrides);
  }

  function toggleSize(form, context, option, genderInputs, menInputs, womenInputs, unifiedInputs) {
    if (context === 'men') {
      setChecked(genderInputs, [GENDER_VALUES.male, GENDER_VALUES.unisex]);
      setChecked(womenInputs, []);
    } else if (context === 'women') {
      setChecked(genderInputs, [GENDER_VALUES.female, GENDER_VALUES.unisex]);
      setChecked(menInputs, []);
    }

    if (unifiedInputs.length) {
      var prefix = context === 'men' ? 'men:' : context === 'women' ? 'women:' : 'all:';
      unifiedInputs.forEach(function (input) {
        if (input.value.indexOf(prefix) !== 0) input.checked = false;
      });
    }

    option.input.checked = !isInputActive(option.input);

    var overrides = {};
    if (context === 'men') {
      overrides[PARAMS.gender] = [GENDER_VALUES.male, GENDER_VALUES.unisex];
    } else if (context === 'women') {
      overrides[PARAMS.gender] = [GENDER_VALUES.female, GENDER_VALUES.unisex];
    }
    submitFilterForm(form, overrides);
  }

  function clearSizes(form, menInputs, womenInputs, unifiedInputs) {
    setChecked(menInputs, []);
    setChecked(womenInputs, []);
    setChecked(unifiedInputs, []);
    submitFilterForm(form);
  }

  function renderFilter(form) {
    if (form.dataset.unifiedFootwearEnhanced === 'true') return;

    var genderInputs = inputs(form, PARAMS.gender);
    var menInputs = inputs(form, PARAMS.menSize);
    var womenInputs = inputs(form, PARAMS.womenSize);
    var unifiedInputs = inputs(form, PARAMS.unifiedSize);

    if (!genderInputs.length || (!menInputs.length && !womenInputs.length && !unifiedInputs.length)) {
      return;
    }

    form.dataset.unifiedFootwearEnhanced = 'true';

    var genderGroup = sourceGroup(genderInputs[0]);
    var menGroup = sourceGroup(menInputs[0]);
    var womenGroup = sourceGroup(womenInputs[0]);
    var unifiedGroup = sourceGroup(unifiedInputs[0]);

    hideSourceGroups([genderGroup, menGroup, womenGroup, unifiedGroup]);
    hideNativeActiveTags(form);

    var context = currentContext(genderInputs);
    var wrapper = document.createElement('div');
    wrapper.className = 'collection-sidebar__group--no-unified-footwear no-unified-footwear-filter';

    var audienceShell = createCollapsibleSection('Gender', 'gender', context !== 'all');
    var audienceSection = audienceShell.section;

    var audienceButtons = document.createElement('div');
    audienceButtons.className = 'no-unified-footwear-filter__audience';
    audienceButtons.setAttribute('role', 'group');
    audienceButtons.setAttribute('aria-label', 'Gender');

    [
      { value: 'all', label: 'All' },
      { value: 'men', label: "Men's" },
      { value: 'women', label: "Women's" }
    ].forEach(function (choice) {
      var button = makeButton(
        choice.label,
        'no-unified-footwear-filter__audience-button',
        context === choice.value
      );
      button.addEventListener('click', function () {
        if (context === choice.value) return;
        setGender(form, choice.value, genderInputs, menInputs, womenInputs, unifiedInputs);
      });
      audienceButtons.appendChild(button);
    });

    audienceShell.content.appendChild(audienceButtons);

    var sizeOptions = buildSizeOptions(context, menInputs, womenInputs, unifiedInputs);
    var hasActiveSize = sizeOptions.some(function (option) {
      return isInputActive(option.input);
    });
    var sizeShell = createCollapsibleSection('Shoe Size', 'shoe-size', hasActiveSize);
    var sizeSection = sizeShell.section;
    var sizeHeadingRow = sizeShell.headingRow;

    if (hasActiveSize) {
      var clearButton = document.createElement('button');
      clearButton.type = 'button';
      clearButton.className = 'no-unified-footwear-filter__clear';
      clearButton.textContent = 'Clear';
      clearButton.addEventListener('click', function () {
        clearSizes(form, menInputs, womenInputs, unifiedInputs);
      });
      sizeHeadingRow.appendChild(clearButton);
    }

    if (!unifiedInputs.length && context === 'all') {
      var prompt = document.createElement('p');
      prompt.className = 'no-unified-footwear-filter__prompt';
      prompt.textContent = "Select Men's or Women's above, then choose your shoe size.";
      sizeShell.content.appendChild(prompt);
    } else {
      var sizeGrid = document.createElement('div');
      sizeGrid.className = 'no-unified-footwear-filter__sizes';
      sizeGrid.setAttribute('role', 'group');
      sizeGrid.setAttribute('aria-label', 'Shoe Size');

      sizeOptions.forEach(function (option) {
        var text = option.count ? option.label + ' (' + option.count + ')' : option.label;
        var button = makeButton(
          text,
          'no-unified-footwear-filter__size-button',
          isInputActive(option.input)
        );
        button.addEventListener('click', function () {
          toggleSize(form, context, option, genderInputs, menInputs, womenInputs, unifiedInputs);
        });
        sizeGrid.appendChild(button);
      });

      sizeShell.content.appendChild(sizeGrid);
    }

    wrapper.appendChild(audienceSection);
    wrapper.appendChild(sizeSection);

    if (genderGroup && genderGroup.parentNode) {
      genderGroup.parentNode.insertBefore(wrapper, genderGroup);
    } else {
      form.insertBefore(wrapper, form.firstChild);
    }
  }

  function updateFilterBadge() {
    var form = document.querySelector('.filter-form[data-unified-footwear-enhanced="true"]');
    var button = document.querySelector('.js-drawer-open-collection-filters');
    if (!form || !button) return;

    var genderInputs = inputs(form, PARAMS.gender);
    var menInputs = inputs(form, PARAMS.menSize);
    var womenInputs = inputs(form, PARAMS.womenSize);
    var unifiedInputs = inputs(form, PARAMS.unifiedSize);
    var relevantInputs = genderInputs.concat(menInputs, womenInputs, unifiedInputs);
    var rawTotal = form.querySelectorAll('input[type="checkbox"]:checked').length;
    var rawRelevant = relevantInputs.filter(function (input) { return input.checked; }).length;
    var context = currentContext(genderInputs);
    var sizeOptions = buildSizeOptions(context, menInputs, womenInputs, unifiedInputs);
    var logicalRelevant = (context === 'all' ? 0 : 1) + sizeOptions.filter(function (option) {
      return option.input.checked;
    }).length;
    var logicalTotal = Math.max(0, rawTotal - rawRelevant + logicalRelevant);
    var label = button.textContent.replace(/icon-filter/gi, '').replace(/\(\d+\)\s*$/, '').trim() || 'Filter';

    Array.prototype.slice.call(button.childNodes).forEach(function (node) {
      if (node.nodeType === Node.TEXT_NODE) node.remove();
    });
    button.appendChild(document.createTextNode(' ' + label + (logicalTotal ? ' (' + logicalTotal + ')' : '')));
  }

  function enhance() {
    document.querySelectorAll('.filter-form').forEach(renderFilter);
    updateFilterBadge();
  }

  function scheduleEnhance() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      enhance();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhance);
  } else {
    enhance();
  }

  new MutationObserver(scheduleEnhance).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
